import {PayloadAction} from "../payload-action.interface";
import {AuditEntity} from "./audit.entity";


export class AuditActions{
  static readonly ADD 		  = '[AuditActions] ADD';
  static readonly ADD_ALL   = '[AuditActions] ADD_ALL';
  static readonly REMOVE 		= '[AuditActions] REMOVE';
  static readonly SET 		  = '[AuditActions] SET';

  static addAll(audits: Array<AuditEntity>): PayloadAction{
    return {
      type: AuditActions.ADD_ALL,
      payload: audits
    }
  }

  static add(audit: AuditEntity): PayloadAction{
    return {
      type: AuditActions.ADD,
      payload: audit
    }
  }

  static set(audit: AuditEntity): PayloadAction{

    return {
      type: AuditActions.SET,
      payload: audit
    }
  }

  static remove(id: string): PayloadAction{
    return {
      type: AuditActions.REMOVE,
      payload: id
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/audit/audit.actions.ts